import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Flex } from '@cash-design-system/react'
import { FormBlockerElementCardElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

const CardContainer = styled.div<{ size: { width: string; height: string } }>`
  width: ${props => props.size.width};
  height: ${props => props.size.height};
  border-radius: 1.2rem;
  overflow: hidden;
  box-shadow: ${props => props.theme.dropShadows.tile};
`

const Card = styled.img`
  /* We expect the images to be the same dimensions as the card, but if they are not then we want to cover the background with the image. */
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
`

export const CardElement = ({ image, width, height }: FormBlockerElementCardElement) => {
  const { t } = useTranslation()
  const { darkMode, pxToRem } = useTheme()

  const url = replaceWithCDNImageUrl({ url: darkMode ? image?.dark_url : image?.light_url })

  const size = {
    width: '21rem',
    height: '13.25rem',
  }
  if (width && height) {
    size.width = pxToRem(width)
    size.height = pxToRem(height)
  }

  return (
    <Flex justifyContent="center">
      <CardContainer size={size}>
        <Card src={url} aria-label={t('Image of Card', { context: 'Image label.' })} />
      </CardContainer>
    </Flex>
  )
}
